<template>
  <v-card class="pa-4" elevation="0">
    <!-- Page 1: Cover -->
    <div id="page1">
      <div class="header">
        {{ $t('A instituição') }}
        <br />
        {{ institutionName }}
        <br />
        A/C: {{ toCareUser.name }}
      </div>

      <div class="pa-2">
        <br />
        <br />

        <p>
          {{ $t('ASSUNTO: Relatório de Desempenho') }}
        </p>

        <br />

        <p>
          {{
            $t(
              'Vimos por meio deste, formalizar a entrega do Relatório de Desempenho das atividades desempenhadas pelo setor durante o período na instituição'
            )
          }}
          {{ institutionName }}.
        </p>

        <br />

        <p>
          {{
            $t(
              'Para elaboração do mesmo, utilizamos os dados de apoio e indicadores gerados pelo software FixSystem - Software de gestão. Outros indicadores, listagens especificas ou maiores informações sobre o parque de equipamentos poderão ser solicitados pela administração se necessário.'
            )
          }}
        </p>

        <br />

        <p>
          {{
            $t(
              'A equipe permanece a inteira disposição e disponibiliza o contato dos responsáveis técnicos abaixo para o caso de qualquer dúvida:'
            )
          }}
        </p>

        <br />
        <br />

        <div class="d-flex justify-space-around">
          <div class="text-center">
            {{ user.name }}
            <br />
            {{
              institution.userType === 0
                ? 'Master'
                : $t(offices[institution.userOffice])
            }}
            <br />
            {{ user.cellPhoneNumber }}
          </div>

          <div class="text-center">
            {{ reviser.name }}
            <br />
            {{ reviser.userOffice }}
            <br />
            {{ reviser.cellPhoneNumber }}
          </div>
        </div>

        <br />
      </div>
    </div>

    <v-divider class="ma-4"></v-divider>

    <!-- Page 2: Objectives & Events -->
    <div id="page2">
      <div class="pa-2">
        <h2 class="primary--text my-4">{{ $t('Objetivos') }}:</h2>

        <p>
          {{
            'O presente relatório tem por objetivo apresentar os indicadores de desempenho, bem como as principais atividades realizadas pelo setor na instituição'
          }}
          {{ institutionName }}.
        </p>

        <br />

        <h2 class="primary--text my-4">
          {{ $t('Principais eventos do período') }}:
        </h2>

        <p class="text-start" style="white-space: pre-wrap">
          {{ lastEvents }}
        </p>

        <br />

        <h2 class="primary--text my-4">
          {{ $t('Eventos previstos para o próximo mês') }}:
        </h2>

        <p class="text-start" style="white-space: pre-wrap">
          {{ nextEvents }}
        </p>
      </div>
    </div>

    <v-divider class="ma-4"></v-divider>

    <!-- Page 3: Table of Contents -->
    <div class="page3">
      <div class="pa-2">
        <h2 class="primary--text">{{ $t('Indicadores de Desempenho') }}:</h2>
        <br />

        <p>
          {{
            $t(
              'O sistema de gestão da qualidade atualmente acompanha e supervisiona os seguintes indicadores de desempenho'
            )
          }}:
        </p>

        <br />

        <template v-for="cat in categoriesWithChartInfos">
          <div
            :key="cat.id + '-header'"
            class="d-flex align-center primary--text mt-4 mb-2"
          >
            <h2 class="mr-2">{{ cat.prefix }}.0</h2>
            <span style="font-size: 18px">
              {{ $t(cat.headerKey) }}
            </span>
          </div>

          <ul :key="cat.id + '-list'">
            <li
              v-for="ind in getChartInfoIndicators(cat.id)"
              :key="ind.id"
            >
              <div class="d-flex align-center">
                <h3 class="mr-2">
                  {{ cat.prefix }}.{{ ind.displayNumber }}
                </h3>
                <span>{{ $t(ind.nameKey) }}</span>
              </div>
            </li>
          </ul>

          <br :key="cat.id + '-br'" />
        </template>
      </div>
    </div>

    <v-divider class="ma-4"></v-divider>

    <!-- Page 4+: Indicator Details -->
    <template v-for="cat in categoriesWithChartInfos">
      <div :key="cat.id + '-detail'" class="my-4">
        <div class="header">
          <div class="d-flex align-center ml-2" style="font-size: 16px">
            <h3 class="mr-2">{{ cat.prefix }}.0</h3>
            {{ $t(cat.headerKey) }}
          </div>
        </div>

        <IndicatorResultPanel
          v-for="ind in getChartInfoIndicators(cat.id)"
          :key="ind.id"
          :indicator="ind"
          :chartInfos="chartInfos"
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <v-divider :key="cat.id + '-divider'" class="ma-4"></v-divider>
    </template>

    <!-- Submit -->
    <v-col cols="12">
      <v-card-actions class="justify-space-between">
        <v-btn text @click="$emit('back')">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('Voltar') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn text @click="submit" :loading="loading">
          {{ $t('Confirmar') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-col>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import GeneralService from '../../../../../../services/GeneralService'
import IndicatorResultPanel from './IndicatorResultPanel.vue'
import {
  CATEGORIES,
  getVisibleIndicators,
  getCategoriesWithChartInfos,
  getChartInfoIndicatorsForCategory,
} from '../../../indicators/indicatorRegistry'

export default {
  name: 'GenerateReportResult',

  components: {
    IndicatorResultPanel,
  },

  props: {
    selection: Array,
    lastEvents: String,
    nextEvents: String,
    reviser: Object,
    toCareUser: Object,
    chartInfos: Array,
    unidades: Array,
    institutionName: String,
    link: String,
    isEditing: Boolean,
    reportId: String,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.user = JSON.parse(localStorage.getItem('user'))
    await this.getStandardEquipments()
  },

  data() {
    return {
      user: {},
      apiService: new ApiService(),
      generalService: new GeneralService(),
      institution: {},
      standardEquipments: [],
      loading: false,
      offices: [
        'Auxiliar',
        'Coordenador',
        'Enfermeiro',
        'Engenheiro',
        'Estagiário',
        'Recepcionista',
        'Supervisor',
        'Técnico',
        'Farmacêutico',
        'Fisioterapeuta',
        'Administrativo',
        'Gerente',
        'Nutricionista',
        'Master',
      ],
    }
  },

  computed: {
    categoriesWithChartInfos() {
      return getCategoriesWithChartInfos(this.chartInfos, this.institution)
    },
  },

  methods: {
    getChartInfoIndicators(categoryId) {
      return getChartInfoIndicatorsForCategory(
        categoryId,
        this.chartInfos,
        this.institution
      )
    },

    submit() {
      this.loading = true
      const model = {
        institutionId: this.institution.id,
        link: this.link,
        content: JSON.stringify({
          institutionName: this.institutionName,
          reviser: {
            name: this.reviser.name,
            userOffice: this.reviser.userOffice,
            cellPhoneNumber: this.reviser.cellPhoneNumber,
          },
          executionUser: {
            name: this.user.name,
            userOffice:
              this.institution.userType === 0
                ? 13
                : this.institution.userOffice,
            cellPhoneNumber: this.institution.cellPhoneNumber,
          },
          toCareUser: {
            name: this.toCareUser.name,
            userOffice: this.toCareUser.userOffice,
            cellPhoneNumber: this.toCareUser.cellPhoneNumber,
          },
          lastEvents: this.lastEvents,
          nextEvents: this.nextEvents,
          chartInfos: this.chartInfos.map((x) => {
            return {
              ...x,
              data: null,
              dataUrl: null,
            }
          }),
        }),
      }

      let url = 'generatedReport/add'
      if (this.isEditing) {
        url = 'generatedReport/edit'
        model.id = this.reportId
      }

      this.apiService
        .post(url, model)
        .then((response) => {
          this.$toast.success('Relatório gerado com sucesso')
          window.open(`generatedReport/${this.link}`, '_blank').focus()
          this.$emit('confirm')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async getStandardEquipments() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )
    },
  },
}
</script>

<style scoped>
.header {
  padding: 10px;
  background: #0f3565;
  color: white;
  border-radius: 6px;
  border-top-right-radius: 37px;
}
</style>
